export const FarmerColumns = [
    "SNo",
 	"FarmerName",
    "FarmerCode",	
    "FarmType",	
    "Place",	
    "District",	
    "State",
    "ContactDetails",
    "MPEDARegistrationStatus",
    "MPEDARegistrationNo",	
    "FarmCode",
    "FarmName",
    "FarmAddress",
    "NoOfAcres",
    "NoOfPonds",
    "TraceCode",
    "Certification",
    "CertificationCode",
    "ExpiryDate",
    "CultureStatus",	
    "AreaUnderCultureInAcrs",
    "DateOfStockIn",
    "QtyOfStockIn",
    "DealerName",
    "Feed",
    "Seed",	
    "DOC",
    "Count",
    "BiomassInMts",
    "Remarks",
    "Comments"
]